import React, { createContext } from 'react'

import { useQuery } from '@/api'
import { DEFAULT_CONTEXT_VALUES, RELATED_PRODUCTIONS_ENDPOINT } from '@/constants'
import type { DefaultProviderProps } from '@/types/app-types'

import { dateSwitcherSheetSelector, i18nRelatedProductionsDataSelector } from './selectors'
import type { QueryResponse, Selectors, State } from './types'

interface ContextValue {
    state: State
    selectors: Selectors
}

const context = createContext<ContextValue>(DEFAULT_CONTEXT_VALUES)

interface Params {
    performerId?: number
    opponentId?: number
    categoryId?: number
    venueId?: number
    sortBy?: 'DATE' | 'NAME' | 'NONE' | 'RANK'
    currency?: string
}

type Props = DefaultProviderProps<State, Params>

export const RelatedProductionsProvider: React.FC<Props> = ({
    children,
    initialFetchDisabled,
    initialParams,
    enabled,
}) => {
    const { data, error, fetching } = useQuery<QueryResponse>({
        endpoint: RELATED_PRODUCTIONS_ENDPOINT,
        params: initialParams,
        initialFetchDisabled,
        enabled,
    })

    const state = { data, error, fetching }
    const selectors = {
        dateSwitcherSheetSelector: dateSwitcherSheetSelector(state),
        i18nRelatedProductionsDataSelector: i18nRelatedProductionsDataSelector(state),
    }

    return <context.Provider value={{ state, selectors }}>{children}</context.Provider>
}

export default context
